import { render, staticRenderFns } from "./invite-single.vue?vue&type=template&id=568053c9&"
import script from "./invite-single.vue?vue&type=script&lang=js&"
export * from "./invite-single.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports